<div class="main-container">
  <div class="logo">
    <kp-reflect-animation [skipIntro]="true"></kp-reflect-animation>
  </div>
  <div class="product-logo">
    <svg-icon [src]="(themeService.theme$ | async)?.onBackgroundIconUrlWithTag"></svg-icon>
  </div>
  <h1 class="title">Ready to feel — and be — your best?</h1>
  <p class="summary">Get started in just a few minutes.</p>
  <button type="button" class="button button-pill" (click)="signUp()">Sign up</button>
  <p class="signin-question">Already have a Kumanu account?</p>
  <a routerLink="/login" class="button-text">Sign in</a>
</div>
